<template>
    <div class="mb-3">
        <button class="btn btn-success" @click="$emit('open-modal')">
            + {{ $t('add_income_category') }}
        </button>
    </div>
</template>

<script>
export default {
    name: 'ExpenseTopButtons'
}
</script>
